import { Box } from '@moonpig/launchpad-components'
import React, { FC, PropsWithChildren, useEffect } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { useInView } from 'react-intersection-observer'
import { system as s } from '@moonpig/launchpad-system'
import { useHasScrolled } from '../../../utils'

const StyledFiltersCarouselBox = styled(Box)`
  position: sticky;
  top: 0px;
  z-index: 500;

  ${s({
    bgcolor: 'colorBackground01',
  })}

  &[data-sticky='true'] {
    ${s({
      borderBottom: 1,
      borderColor: 'colorBorder03',
    })}
  }
`

export const FiltersCarouselStickyWrapper: FC<
  PropsWithChildren<{ onStickyChange?: (sticky: boolean) => void }>
> = ({ children, onStickyChange }) => {
  const [filtersCarouselRef, inView] = useInView({
    threshold: 1,
  })
  const hasScrolled = useHasScrolled()

  useEffect(() => {
    if (hasScrolled && onStickyChange) {
      onStickyChange(!inView)
    }
  }, [onStickyChange, inView, hasScrolled])

  return (
    <>
      <div
        ref={filtersCarouselRef}
        style={{ height: 1 }}
        data-testid={'sticky-filters-carousel-sentinel'}
      />
      <StyledFiltersCarouselBox
        data-testid="sticky-filters-carousel"
        data-sticky={!inView}
      >
        {children}
      </StyledFiltersCarouselBox>
    </>
  )
}
